module.exports = __webpack_public_path__ + "static/img/W.fe688f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qdzy/W.png
// module id = 4Tgy
// module chunks = 0